'use strict';

import { getPaddedNumber } from "./TextHelper";
import { SITECODES } from "../Constants/siteCodes";
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var dayNamesSmall = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export var DATE_FORMATS;
(function (DATE_FORMATS) {
  DATE_FORMATS[DATE_FORMATS["DD/MM/YY"] = 0] = "DD/MM/YY";
  DATE_FORMATS[DATE_FORMATS["Day, DD Month"] = 1] = "Day, DD Month";
  DATE_FORMATS[DATE_FORMATS["DayS, DD Month"] = 2] = "DayS, DD Month";
  DATE_FORMATS[DATE_FORMATS["DD"] = 3] = "DD";
  DATE_FORMATS[DATE_FORMATS["DD Month"] = 4] = "DD Month";
  DATE_FORMATS[DATE_FORMATS["Day"] = 5] = "Day";
  DATE_FORMATS[DATE_FORMATS["DD Month YYYY"] = 6] = "DD Month YYYY";
  DATE_FORMATS[DATE_FORMATS["DD Month YYYY hh:mm"] = 7] = "DD Month YYYY hh:mm";
  DATE_FORMATS[DATE_FORMATS["YYYY-MM-DD hh:mm"] = 8] = "YYYY-MM-DD hh:mm";
  DATE_FORMATS[DATE_FORMATS["YYYY-MM-DDThh:mm:ss+05:30"] = 9] = "YYYY-MM-DDThh:mm:ss+05:30";
  DATE_FORMATS[DATE_FORMATS["DD-MON-YY"] = 10] = "DD-MON-YY";
  DATE_FORMATS[DATE_FORMATS["YYYY-MM-DD"] = 11] = "YYYY-MM-DD";
})(DATE_FORMATS || (DATE_FORMATS = {}));
export var TIME_FORMATS;
(function (TIME_FORMATS) {
  TIME_FORMATS[TIME_FORMATS["hh:mm am/pm"] = 0] = "hh:mm am/pm";
})(TIME_FORMATS || (TIME_FORMATS = {}));
export var formatDate = function formatDate(dateObj, format) {
  var date = dateObj.getDate();
  var month = dateObj.getMonth();
  var year = dateObj.getFullYear();
  var hours = dateObj.getHours();
  var minutes = dateObj.getMinutes();
  var seconds = dateObj.getSeconds();
  var monthNum = month + 1;
  var DD = getPaddedNumber(date);
  var MM = getPaddedNumber(monthNum);
  var YY = String(year).substr(2);
  var hh = getPaddedNumber(hours);
  var mm = getPaddedNumber(minutes);
  var ss = getPaddedNumber(seconds);
  var formattedDate = '';
  switch (format) {
    case DATE_FORMATS['DD/MM/YY']:
      {
        formattedDate = "".concat(DD, "/").concat(MM, "/").concat(YY);
        break;
      }
    case DATE_FORMATS['Day, DD Month']:
      {
        formattedDate = "".concat(dayNames[dateObj.getDay()], ", ").concat(DD, " ").concat(monthNames[month]);
        break;
      }
    case DATE_FORMATS['DayS, DD Month']:
      {
        formattedDate = "".concat(dayNamesSmall[dateObj.getDay()], ", ").concat(DD, " ").concat(monthNames[month]);
        break;
      }
    case DATE_FORMATS.DD:
      {
        formattedDate = "".concat(DD);
        break;
      }
    case DATE_FORMATS.Day:
      {
        formattedDate = "".concat(dayNames[dateObj.getDay()]);
        break;
      }
    case DATE_FORMATS['DD Month']:
      {
        formattedDate = "".concat(DD, " ").concat(monthNames[month]);
        break;
      }
    case DATE_FORMATS['DD Month YYYY']:
      {
        formattedDate = "".concat(DD, " ").concat(monthNames[month], " ").concat(year);
        break;
      }
    case DATE_FORMATS['DD Month YYYY hh:mm']:
      {
        formattedDate = "".concat(DD, " ").concat(monthNames[month], " ").concat(year, " ").concat(hh, ":").concat(mm);
        break;
      }
    case DATE_FORMATS['YYYY-MM-DD hh:mm']:
      {
        formattedDate = "".concat(year, "-").concat(MM, "-").concat(DD, " ").concat(hh, ":").concat(mm);
        break;
      }
    case DATE_FORMATS['YYYY-MM-DD']:
      {
        formattedDate = "".concat(year, "-").concat(MM, "-").concat(DD);
        break;
      }
    case DATE_FORMATS['YYYY-MM-DDThh:mm:ss+05:30']:
      {
        formattedDate = "".concat(year, "-").concat(MM, "-").concat(DD, "T").concat(hh, ":").concat(mm, ":").concat(ss, "+05:30");
        break;
      }
    case DATE_FORMATS['DD-MON-YY']:
      formattedDate = "".concat(DD, "-").concat(monthNames[month].slice(0, 3).toUpperCase(), "-").concat(YY);
  }
  return formattedDate;
};
export var formatTime = function formatTime(dateObj, format) {
  var hours = dateObj.getHours();
  var minutes = dateObj.getMinutes();
  var formattedDate = '';
  switch (format) {
    case TIME_FORMATS['hh:mm am/pm']:
      {
        if (hours >= 13) {
          formattedDate = "".concat(getPaddedNumber(hours - 12), ":").concat(getPaddedNumber(minutes), " pm");
        } else if (hours == 0) {
          formattedDate = "01:".concat(getPaddedNumber(minutes), " am");
        } else {
          formattedDate = "".concat(getPaddedNumber(hours), ":").concat(getPaddedNumber(minutes), " am");
        }
        break;
      }
  }
  return formattedDate;
};
export var isDatePassed = function isDatePassed(a) {
  var b = new Date();
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return utc2 - utc1 > 0;
};
export var getMidnightDate = function getMidnightDate(a) {
  var utc = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  return new Date(utc);
};
export var getFormattedTime = function getFormattedTime(timeString, siteCode) {
  var isglobalTimeRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hideZeroes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hourEnd = timeString.indexOf(':');
  var H = Number(timeString.substr(0, hourEnd));
  var M = Number(timeString.substr(hourEnd + 1, hourEnd.toString().length));
  var h = H % 12 || 12;
  var ampm = H < 12 || H === 24 ? ' AM' : ' PM';
  if (siteCode === SITECODES.OLXTR || isglobalTimeRequired) {
    timeString = H + (M === 0 && hideZeroes ? '' : timeString.substr(hourEnd, 3));
  } else {
    timeString = h + (M === 0 && hideZeroes ? '' : timeString.substr(hourEnd, 3)) + ampm;
  }
  return timeString;
};
export var getDateWithTimeFromSlotDetails = function getDateWithTimeFromSlotDetails(slotDetails) {
  var date = slotDetails.date,
    slot = slotDetails.slot;
  var timeArr = slot.split(':').map(function (str) {
    return Number(str);
  });
  var dateArr = date.split('-').map(function (str) {
    return Number(str);
  });
  return new Date(dateArr[0], dateArr[1] - 1, dateArr[2], timeArr[0], timeArr[1], timeArr[2]);
};
export var getDateFromSlotDetails = function getDateFromSlotDetails(slotDetails) {
  var date = slotDetails.date;
  var dateArr = date.split('-').map(function (str) {
    return Number(str);
  });
  return new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
};
export default {
  formatDate: formatDate,
  formatTime: formatTime,
  isDatePassed: isDatePassed,
  getMidnightDate: getMidnightDate,
  getDateAndTimeFromSlotDetails: getDateWithTimeFromSlotDetails,
  getDateFromSlotDetails: getDateFromSlotDetails,
  getFormattedTime: getFormattedTime
};